import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import { Button, ButtonGroup, Table, Input, Label, Row, Col } from "reactstrap";
import Header from "../../../layout/Header/Header";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import moment from "moment";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { puedeCrm } from "../permisosCrm";
import { etiquetasEtapas, nombreEtapa } from "../etapas";
import { sectorDe, BadgeSector, pasaFiltroSector, OpcionesFiltroSector } from "../sectores";

function ReporteAccionesPendientes() {
  const { user } = useContext(AuthContext);
  const URL_CRM_OPORTUNIDADES = process.env.REACT_APP_URL_CRM_OPORTUNIDADES;
  const URL_CRM_ETAPAS = process.env.REACT_APP_URL_CRM_ETAPAS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const headers = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };

  const [pendientes, setPendientes] = useState([]);
  const [etapas, setEtapas] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [inicio, setInicio] = useState("");
  const [fin, setFin] = useState("");
  const [filtroResponsable, setFiltroResponsable] = useState("");
  const [filtroEtapa, setFiltroEtapa] = useState("");
  // (2026-10) Privado / Gobierno / Sin sector
  const [filtroSector, setFiltroSector] = useState("");
  const [vista, setVista] = useState("lista"); // "lista" | "calendario"
  const [fechaCal, setFechaCal] = useState(new Date());

  useEffect(() => {
    buscar();
    axios.get(URL_CRM_ETAPAS, headers).then((r) => setEtapas(r.data)).catch((e) => console.log(e));
    axios.get(URL_COLABORADORES, headers).then((r) => setUsuarios(r.data)).catch((e) => console.log(e));
  }, []);

  function buscar() {
    let url = `${URL_CRM_OPORTUNIDADES}Pendientes`;
    const params = [];
    if (inicio) params.push(`inicio=${inicio}`);
    if (fin) params.push(`fin=${fin}`);
    if (params.length) url += `?${params.join("&")}`;
    axios.get(url, headers).then((r) => setPendientes(r.data)).catch((e) => console.log(e));
  }

  const hoy = new Date().toISOString().split("T")[0];
  const badgeFecha = (f) => {
    if (!f) return null;
    const vencida = f < hoy;
    return (
      <span className={`badge badge-${vencida ? "danger" : "primary"}`}>{f}{vencida ? " (vencida)" : ""}</span>
    );
  };

  const listaFiltrada = pendientes.filter((o) => {
    if (filtroResponsable && (!o.responsable || o.responsable._id !== filtroResponsable)) return false;
    if (filtroEtapa && (!o.etapa || o.etapa._id !== filtroEtapa)) return false;
    if (!pasaFiltroSector(o.prospecto, filtroSector)) return false;
    return true;
  });

  // Agrupa las acciones pendientes por fecha (para el calendario), respeta filtros.
  const pendientesPorFecha = {};
  listaFiltrada.forEach((o) => {
    const f = o.fecha_proxima_accion;
    if (!f) return;
    if (!pendientesPorFecha[f]) pendientesPorFecha[f] = [];
    pendientesPorFecha[f].push(o);
  });
  const fechaCalStr = moment(fechaCal).format("YYYY-MM-DD");
  const pendientesDelDia = pendientesPorFecha[fechaCalStr] || [];

  const etiquetaEtapa = etiquetasEtapas(etapas);

  // Filas para exportar (respetan los filtros aplicados).
  const filasExport = listaFiltrada.map((o) => [
    o.fecha_proxima_accion || "",
    o.prospecto ? o.prospecto.razon_social : "",
    sectorDe(o.prospecto) || "Sin sector",
    nombreEtapa(etiquetaEtapa, o.etapa),
    o.ultimoComentario || "",
    o.responsable ? `${o.responsable.nombre} ${o.responsable.apellido || ""}` : "",
    Number(o.valor_estimado || 0),
  ]);
  const COLS = ["Fecha próxima", "Prospecto", "Sector", "Etapa", "Comentario", "Responsable", "Valor"];

  function descargarPDF() {
    const doc = new jsPDF("landscape");
    const sufijo =
      filtroSector === "sin" ? " · Sin sector" : filtroSector ? ` · Sector ${filtroSector}` : "";
    doc.text(`Acciones Pendientes${sufijo}`, 14, 15);
    doc.autoTable({
      head: [COLS],
      body: filasExport.map((f) => [
        f[0], f[1], f[2], f[3], f[4], f[5], "$" + Number(f[6]).toLocaleString("es-MX"),
      ]),
      startY: 20,
      styles: { fontSize: 8 },
    });
    doc.save("AccionesPendientes.pdf");
  }

  function descargarExcel() {
    const data = filasExport.map((f) => ({
      "Fecha próxima": f[0], Prospecto: f[1], Sector: f[2], Etapa: f[3],
      Comentario: f[4], Responsable: f[5], Valor: f[6],
    }));
    new ExportJsonExcel({
      fileName: "AccionesPendientes",
      datas: [{ sheetData: data, sheetName: "Pendientes", sheetHeader: COLS }],
    }).saveExcel();
  }

  return (
    <>
      <Header />
      <br />
      <div className="container">
        {puedeCrm(user, "crm.pendientes.ver") ? (
          <div className="card col-12">
            <Row>
              <Col md={8}>
                <Button size="sm" href="/MenuCrm" className="btn btn-danger" id="botonListado">
                  Regresar
                </Button>
              </Col>
              <Col sm={4}>
                <ButtonGroup id="logoutBoton">
                <Button size="sm" className="btn" color="danger" onClick={descargarPDF}>
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button size="sm" className="btn" color="primary" onClick={descargarExcel}>
                  Excel <i class="far fa-file-excel"></i>
                </Button>
                </ButtonGroup>
              
              </Col>
            </Row>
            <h3 align="center">Acciones Pendientes</h3>
            <div style={{ marginBottom: 12 }}>
              <Button
                size="sm"
                color={vista === "lista" ? "info" : "secondary"}
                onClick={() => setVista("lista")}
              >
                <i className="fas fa-list" style={{ marginRight: 6 }} /> Lista
              </Button>{" "}
              <Button
                size="sm"
                color={vista === "calendario" ? "info" : "secondary"}
                onClick={() => setVista("calendario")}
              >
                <i className="far fa-calendar-alt" style={{ marginRight: 6 }} /> Calendario
              </Button>
            </div>
            <Row className="align-items-end">
              <Col md={2}>
                <Label>Desde</Label>
                <Input type="date" bsSize="sm" value={inicio} onChange={(e) => setInicio(e.target.value)} />
              </Col>
              <Col md={2}>
                <Label>Hasta</Label>
                <Input type="date" bsSize="sm" value={fin} onChange={(e) => setFin(e.target.value)} />
              </Col>
              <Col md={2}>
                <Label>Responsable</Label>
                <Input type="select" bsSize="sm" value={filtroResponsable} onChange={(e) => setFiltroResponsable(e.target.value)}>
                  <option value="">Todos</option>
                  {usuarios.map((u) => (
                    <option key={u._id} value={u._id}>{u.nombre} {u.apellido}</option>
                  ))}
                </Input>
              </Col>
              <Col md={2}>
                <Label>Etapa</Label>
                <Input type="select" bsSize="sm" value={filtroEtapa} onChange={(e) => setFiltroEtapa(e.target.value)}>
                  <option value="">Todas</option>
                  {etapas
                    .sort((a, b) => (a.orden > b.orden ? 1 : -1))
                    .map((et) => (
                      <option key={et._id} value={et._id}>{etiquetaEtapa[et._id]}</option>
                    ))}
                </Input>
              </Col>
              <Col md={2}>
                <Label>Sector</Label>
                <Input type="select" bsSize="sm" value={filtroSector} onChange={(e) => setFiltroSector(e.target.value)}>
                  <OpcionesFiltroSector />
                </Input>
              </Col>
              <Col md={2}>
                <Label>&nbsp;</Label>
                <div>
                  <Button color="success" size="sm" onClick={buscar}>
                    <i className="fas fa-search" style={{ marginRight: 6 }} /> Buscar
                  </Button>
                </div>
              </Col>
            </Row>
            <br />
            {vista === "lista" ? (
            <Table size="sm" striped borderless className="table-responsive-xl">
              <thead>
                <tr>
                  <th className="tituloTabla">Fecha próxima</th>
                  <th className="tituloTabla">Prospecto</th>
                  <th className="tituloTabla">Sector</th>
                  <th className="tituloTabla">Etapa</th>
                  <th className="tituloTabla">Comentario</th>
                  <th className="tituloTabla">Responsable</th>
                  <th className="tituloTabla">Valor</th>
                </tr>
              </thead>
              <tbody>
                {listaFiltrada.length === 0 ? (
                  <tr><td colSpan={7} className="text-muted">Sin acciones pendientes en el rango.</td></tr>
                ) : (
                  listaFiltrada.map((o) => (
                    <tr key={o._id}>
                      <td>{badgeFecha(o.fecha_proxima_accion)}</td>
                      <td>{o.prospecto ? o.prospecto.razon_social : "-"}</td>
                      <td><BadgeSector prospecto={o.prospecto} /></td>
                      <td>{nombreEtapa(etiquetaEtapa, o.etapa) || "-"}</td>
                      <td>{o.ultimoComentario || "-"}</td>
                      <td>{o.responsable ? `${o.responsable.nombre} ${o.responsable.apellido || ""}` : "-"}</td>
                      <td>${Number(o.valor_estimado || 0).toLocaleString("es-MX")}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
            ) : (
              <Row>
                <Col md={5}>
                  <Calendar
                    value={fechaCal}
                    onChange={setFechaCal}
                    tileClassName={({ date, view }) => {
                      if (view !== "month") return null;
                      const key = moment(date).format("YYYY-MM-DD");
                      return pendientesPorFecha[key] ? "tiene-pendientes" : null;
                    }}
                    tileContent={({ date, view }) => {
                      if (view !== "month") return null;
                      const key = moment(date).format("YYYY-MM-DD");
                      const cant = pendientesPorFecha[key]?.length || 0;
                      if (cant === 0) return null;
                      const vencida = key < hoy;
                      return (
                        <div style={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
                          <span
                            style={{
                              backgroundColor: vencida ? "#dc3545" : "#003A5C",
                              color: "#fff",
                              fontSize: 10,
                              fontWeight: "bold",
                              borderRadius: 8,
                              padding: "0 5px",
                              lineHeight: "14px",
                              minWidth: 16,
                              textAlign: "center",
                              display: "inline-block",
                            }}
                          >
                            {cant}
                          </span>
                        </div>
                      );
                    }}
                  />
                  <style>{`
                    .tiene-pendientes { background: #ede9fe !important; }
                    .react-calendar { border: 1px solid #dee2e6; border-radius: 6px; padding: 6px; width: 100%; }
                    .react-calendar__tile { padding: 8px 4px; }
                    .react-calendar__tile--active { background: #003A5C !important; color: white !important; }
                  `}</style>
                </Col>
                <Col md={7}>
                  <h5 className="mb-3">
                    Acciones del {moment(fechaCal).format("DD [de] MMMM YYYY")}
                  </h5>
                  {pendientesDelDia.length === 0 ? (
                    <div style={{ padding: 16, backgroundColor: "#f8f9fa", borderRadius: 4, border: "1px solid #dee2e6" }}>
                      <em style={{ color: "#888" }}>Sin acciones pendientes en esta fecha.</em>
                    </div>
                  ) : (
                    <div style={{ maxHeight: 500, overflowY: "auto" }}>
                      {pendientesDelDia.map((o) => (
                        <div
                          key={o._id}
                          style={{
                            borderLeft: `3px solid ${fechaCalStr < hoy ? "#dc3545" : "#003A5C"}`,
                            padding: "10px 14px",
                            marginBottom: 10,
                            backgroundColor: "#f8f9fa",
                            borderRadius: 4,
                          }}
                        >
                          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, color: "#666", marginBottom: 6 }}>
                            <span>
                              <strong>{o.prospecto ? o.prospecto.razon_social : "Prospecto"}</strong>{" "}
                              {sectorDe(o.prospecto) ? <BadgeSector prospecto={o.prospecto} /> : null}
                              {o.etapa ? ` · ${nombreEtapa(etiquetaEtapa, o.etapa)}` : ""}
                            </span>
                            <span>
                              <em>{o.responsable ? `${o.responsable.nombre} ${o.responsable.apellido || ""}` : "Sin asignar"}</em>
                            </span>
                          </div>
                          {o.ultimoComentario && (
                            <div style={{ whiteSpace: "pre-wrap", marginBottom: 4 }}>{o.ultimoComentario}</div>
                          )}
                          <div style={{ fontSize: 12, color: "#198754", fontWeight: 600 }}>
                            ${Number(o.valor_estimado || 0).toLocaleString("es-MX")}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </Col>
              </Row>
            )}
          </div>
        ) : undefined}
      </div>
    </>
  );
}

export default ReporteAccionesPendientes;
